/**
 */

import React from 'react';

export const Description = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.09375 8.06543H12.3309"
      stroke={color ?? '#7D7A9A'}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4.09375 5.24659L13.2573 5.24658"
      stroke={color ?? '#7D7A9A'}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4.09375 10.8984L13.9076 10.8984"
      stroke={color ?? '#7D7A9A'}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4.09375 13.7319L8.31037 13.7319"
      stroke={color ?? '#7D7A9A'}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
